module.exports = __webpack_public_path__ + "img/i4.d5f99afd.svg";